import React from "react";
import ContentLoader from "react-content-loader";

const HelpLinksLoader = () => (
  <ContentLoader
    width="100%"
    height="405px"
    viewBox="0 0 610 405"
    backgroundColor="#687592"
    foregroundColor="#dbdbdb"
  >
    <rect x="4" y="8" rx="3" ry="3" width="8" height="405" />
    <rect x="7" y="397" rx="3" ry="3" width="610" height="8" />
    <rect x="603" y="9" rx="3" ry="3" width="7" height="405" />
    <rect x="5" y="8" rx="3" ry="3" width="610" height="7" />
    <rect x="470" y="24" rx="6" ry="6" width="110" height="56" />
    <rect x="80" y="24" rx="6" ry="6" width="80" height="56" />
    <circle cx="40" cy="50" r="24" />
    <rect x="470" y="100" rx="6" ry="6" width="110" height="56" />
    <rect x="80" y="100" rx="6" ry="6" width="80" height="56" />
    <circle cx="40" cy="128" r="24" />
    <rect x="470" y="176" rx="6" ry="6" width="110" height="56" />
    <rect x="80" y="176" rx="6" ry="6" width="80" height="56" />
    <circle cx="40" cy="206" r="24" />
    <rect x="470" y="252" rx="6" ry="6" width="110" height="56" />
    <rect x="80" y="252" rx="6" ry="6" width="80" height="56" />
    <circle cx="40" cy="284" r="24" />
    <rect x="470" y="328" rx="6" ry="6" width="110" height="56" />
    <rect x="80" y="328" rx="6" ry="6" width="80" height="56" />
    <circle cx="40" cy="360" r="24" />
  </ContentLoader>
);

HelpLinksLoader.metadata = {
  name: "Sridhar Easwaran",
  github: "sridhareaswaran",
  description: "HelpLinks",
  filename: "HelpLinksLoader",
};

export default HelpLinksLoader;
